
import React from 'react';
import { Input } from "@/components/ui/input";
import { Search } from 'lucide-react';

interface ReportSearchProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  placeholder: string;
}

const ReportSearch: React.FC<ReportSearchProps> = ({ searchTerm, onSearchChange, placeholder }) => {
  return (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground h-4 w-4" />
      <Input
        placeholder={placeholder}
        className="pl-9"
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
      />
    </div>
  );
};

export default ReportSearch;
